import { Col, Row } from 'react-bootstrap';
import Select, { components } from 'react-select';
import React, { useState } from 'react';
import SharedSpecialtyLogic from './shared';
import { specialtiesPropTypes } from './shared';

const SALE = 'sale';
const LEASE = 'lease';
const SALE_AND_LESE = 'sale_and_lease';

function createSpecialtiesOptions(allBrokerSpecialties) {
  const saleSpecialties = allBrokerSpecialties.filter(s => s.propertyType === SALE ||
    s.propertyType === SALE_AND_LESE);
  const saleOptions = saleSpecialties.map(s => ({ label: s.title, value: `${s.id}-${SALE}` }));

  const leaseSpecialties = allBrokerSpecialties.filter(s => s.propertyType === LEASE ||
    s.propertyType === SALE_AND_LESE);
  const leaseOptions = leaseSpecialties.map(s => ({ label: s.title, value: `${s.id}-${LEASE}` }));

  return { saleOptions, leaseOptions };
}

function createSelectedSpecialties(userSpecialties) {
  return userSpecialties.reduce((accumulator, specialty) => {
    if (specialty.propertyType === SALE_AND_LESE) {
      accumulator.push(`${specialty.brokerSpecialtyId}-${SALE}`);
      accumulator.push(`${specialty.brokerSpecialtyId}-${LEASE}`);
    } else {
      accumulator.push(`${specialty.brokerSpecialtyId}-${specialty.propertyType}`);
    }
    return accumulator;
  }, []);
}

function getPropertyType(propertyTypes) {
  if (propertyTypes.length === 2) {
    return SALE_AND_LESE;
  } else {
    return propertyTypes[0];
  }
}

function MultiValueLabel(props) {
  // eslint-disable-next-line no-unused-vars
  const [_, propertyType] = props.data.value.split('-');

  return (
    <components.MultiValueLabel {...props}>
      <span className="text-capitalize">
        {props.data.label} - {propertyType}
      </span>
    </components.MultiValueLabel>
  );
}

export default function GroupedSpecialties({
  allBrokerSpecialties,
  pcUser,
  showSpecialtiesOnBrokerPlugin,
  userSpecialties
}) {
  const [selectedSpecialties, setSelectedSpecialties] = useState(() => createSelectedSpecialties(userSpecialties));

  function changeSelectedCertifications(selectedOptions) {
    setSelectedSpecialties(selectedOptions.map(option => option.value));
  }

  const { saleOptions, leaseOptions } = createSpecialtiesOptions(allBrokerSpecialties);

  const selectedOptionsById = selectedSpecialties.reduce((accumulator, currentValue) => {
    const [id, saleOrLease] = currentValue.split('-');
    if (accumulator[id]) {
      accumulator[id].values.push(saleOrLease);
    } else {
      accumulator[id] = { values: [saleOrLease] };
    }

    return accumulator;
  }, {});

  const specialtiesOptions = [
    {
      label: 'Sale',
      options: saleOptions
    },
    {
      label: 'Lease',
      options: leaseOptions
    }
  ];
  const specialtiesValue = [
    ...saleOptions.filter(s => selectedSpecialties.includes(s.value)),
    ...leaseOptions.filter(s => selectedSpecialties.includes(s.value))
  ];

  return (
    <React.Fragment>
      <Row className="form-group">
        <Col md={6}>
          <Select
            classNamePrefix="react-select-buildout"
            components={{ MultiValueLabel }}
            isMulti
            options={specialtiesOptions}
            value={specialtiesValue}
            onChange={selectedOptions => changeSelectedCertifications(selectedOptions)}
          />
        </Col>
      </Row>

      <SharedSpecialtyLogic
        getPropertyType={getPropertyType}
        pcUser={pcUser}
        selectedOptionsById={selectedOptionsById}
        showSpecialtiesOnBrokerPlugin={showSpecialtiesOnBrokerPlugin}
        userSpecialties={userSpecialties}
      />
    </React.Fragment>
  );
}

GroupedSpecialties.propTypes = specialtiesPropTypes;
